<app-mazars-avatar-group *ngIf="userDatails" [userDetails]="userDatails" [uid]="'channel-avatar-group-' + channel?.id"></app-mazars-avatar-group>